module.exports = require('./lib/heap');



// WEBPACK FOOTER //
// ./node_modules/heap/index.js